import { REQS } from './constants.js';

export const zonesAt = (G, i) => G.zonesAt?.[i] || (G.zone[i] >= 0 ? [G.zone[i]] : []);
export const zoneViews = (z, cfg = {}) => Math.max(z?.views || 1, cfg.redundancy && ['identify', 'plate'].includes(z?.req) ? 2 : 1);

/** Independent demands at the same physical point. A face and a plate may be
 * supplied by different cameras; overlapping zones must never erase a goal.
 * The general requirement is a fallback. An explicit area requirement remains
 * binding even where a zone overlaps it. */
export function planningGrid(S, grid, cfg = {}) {
  const cell = [], req = [], zone = [], views = [], area = [], sx = [], sy = [];
  const cellDemandCount = new Uint16Array(grid.n);
  const add = (i, requirement, zi, count) => {
    cell.push(i); req.push(requirement); zone.push(zi); views.push(count);
    area.push(grid.area[i]); sx.push(grid.sx[i]); sy.push(grid.sy[i]); cellDemandCount[i]++;
  };
  for (let i = 0; i < grid.n; i++) if (grid.inSite[i]) {
    if (grid.baseReq[i] >= 0) add(i, grid.baseReq[i], -1, 1);
    for (const zi of zonesAt(grid, i)) add(i, REQS.findIndex(r => r.k === S.zones[zi].req), zi, zoneViews(S.zones[zi], cfg));
  }
  return { ...grid, physical: grid, n: cell.length, cell: Int32Array.from(cell),
    cellDemandCount, req: Uint8Array.from(req), zone: Int16Array.from(zone), views: Uint8Array.from(views),
    area: Int16Array.from(area), sx: Float32Array.from(sx), sy: Float32Array.from(sy), inSite: new Uint8Array(cell.length).fill(1) };
}
